module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Regular--ba6cad25afe01d394e830f548a7f94df.ba6cad25afe01d394e830f548a7f94df.ttf";